import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiClientService, TENANT_API } from '@pharvio/core/shared';
import { DashboardDataService } from './dashboard-data.service';
import { DashboardKpis } from '../models/dashboard.model';

@Injectable()
export class HttpDashboardDataService extends DashboardDataService {
  private readonly api = inject(ApiClientService);

  getKpis(branchId?: string): Observable<DashboardKpis> {
    return this.api.get<DashboardKpis>(TENANT_API.DASHBOARD.KPIS, branchId ? { branchId } : {});
  }
}
